/**
 * 출금계좌메모(F열): 상호명 앞 2글자 + 차량번호 뒤 4글자
 * 예) 지리산물류 + 대전88아5117 → 지리5117
 */
export function withdrawalAccountMemoFrom(businessName: string, vehicleNumber: string): string {
  const biz = String(businessName ?? '').trim();
  const vn = String(vehicleNumber ?? '').replace(/\s/g, '');
  const prefix = Array.from(biz).slice(0, 2).join('');
  const suffix =
    vn.length === 0 ? '' : vn.length <= 4 ? vn : Array.from(vn).slice(-4).join('');
  return `${prefix}${suffix}`;
}
